import React from "react";

import { useTranslation } from "utils";

import { MainPage, Typography } from "components";

export const TranslationBranching = () => {
  const { t } = useTranslation("global");

  return (
    <MainPage loading={false} pageName={"admin"}>
      <Typography variant="paragraph-m">{t("experiments.testString1")}</Typography>
    </MainPage>
  );
};
